exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".images[data-v-a182050a]{opacity:0;position:absolute;width:54px;height:27px;left:3px}.detail-centent[data-v-a182050a]{line-height:30px;font-size:14px}.textE93323[data-v-a182050a]{color:#e93323}.detail-title[data-v-a182050a]{font-size:16px}", ""]);

// exports
